/* eslint-disable react/no-array-index-key */
import { useMemo, Fragment } from "react"
import tw from "twin.macro"

import Section from "components/Section"
import Grid from "components/Grid"
import Column from "components/Column"
import FeaturedWord from "components/FeaturedWord"
import AudioPlayer from "components/AudioPlayer"

import { IntroBody } from "styles/Text"
import { StoryHeader } from "pages/story/[story]"

enum WordType {
  TEXT = "text",
  FEATURED = "featured",
}

const StoryBlock = ({
  id,
  storyId,
  text,
  text_english,
  audio = null,
  featuredWords = [],
  audioOnClick,
  audioActive,
}) => {
  // Extract and markup featured words in the text
  const textArray = useMemo(() => {
    if (featuredWords.length <= 0) {
      return [{ type: WordType.TEXT, text }]
    }
    const featuredWordsRX = new RegExp(
      `\\b(${featuredWords
        .map(({ markedup_text }) => markedup_text)
        .join("|")})\\b`,
      "gi"
    )

    let match
    let lastIndex = 0
    const wordArray = []
    // eslint-disable-next-line no-cond-assign
    while ((match = featuredWordsRX.exec(text)) !== null) {
      const [, matchedWord] = match
      wordArray.push({
        type: WordType.TEXT,
        text: text.slice(lastIndex, match.index),
      })
      lastIndex = match.index + matchedWord.length
      const ftWord = featuredWords.find((w) => w.markedup_text === matchedWord)
      wordArray.push({
        type: WordType.FEATURED,
        text: matchedWord,
        ...ftWord,
      })
    }

    wordArray.push({
      type: WordType.TEXT,
      text: text.slice(lastIndex),
    })

    return wordArray
  }, [text, featuredWords])

  return (
    <Section>
      <Grid>
        <Column
          size={{ md: 13 / 24, lg: 1 / 2 }}
          tw="flex flex-wrap items-baseline lg:flex-nowrap"
        >
          <div tw="md:hidden w-full mb-4">
            <StoryHeader as="h3">Bunuba Language</StoryHeader>
          </div>
          {audio && (
            <div tw="order-1 w-2/12 md:(order-none) lg:(w-8 mr-6 -ml-14 w-auto)">
              <AudioPlayer
                onClick={audioOnClick}
                active={audioActive}
                src={audio}
                track={`/api/stories/${storyId}/${id}/bck.vtt`}
                tw="m-0"
              />
            </div>
          )}
          <IntroBody tw="text-med-grey w-10/12 lg:w-auto" lang="bck">
            {textArray.map((node, idx) =>
              node.type === WordType.FEATURED ? (
                <FeaturedWord key={idx} {...node} />
              ) : (
                <Fragment>{node.text}</Fragment>
              )
            )}
          </IntroBody>
        </Column>
        <Column size={{ md: 11 / 24 }}>
          <div tw="md:hidden w-full mt-9 mb-4">
            <StoryHeader as="h3">English Translation</StoryHeader>
          </div>
          <IntroBody tw="text-med-grey">{text_english}</IntroBody>
        </Column>
      </Grid>
    </Section>
  )
}

export default StoryBlock
